import Evidence from '../evidence';

/**
 * Create the action
 */

const { thunk, request, success, error } = Evidence.destroy(({ evidenceId }, fetch) => {
    return fetch.post(`/destroy-evidence/${evidenceId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };